<div class="d-flex h-100">
  <div
    class="side-list"
    [ngClass]="[
      !dataSourceSelectedLength && selectedId === commonService.defaultGuidValue
        ? 'edit'
        : '',
      closeMenu ? 'hide-sidelist' : ''
    ]"
  >
    <div class="side-list-wrapper h-100">
      <div
        class="d-flex justify-space-between align-items-center side-list-header"
      >
        <div class="d-flex align-items-center">
          <mat-checkbox
            [(ngModel)]="isAllSelected"
            (change)="selectAll($event)"
            disableRipple
          ></mat-checkbox>
          <span class="clamp side-list-header-text" title="{{ headerText }}">
            {{ headerText }}</span
          >
        </div>
        <div class="side-list-icon">
          <button
            mat-button
            class="search"
            disableRipple
            (click)="toggleSearchBar()"
          >
            <mat-icon [ngClass]="showSearchBar ? 'text-primary' : ''"
              >search</mat-icon
            >
          </button>
          <button mat-button (click)="addClick()" disableRipple>
            <mat-icon>add_circle</mat-icon>
          </button>
        </div>
      </div>
      <div class="side-list-search" *ngIf="showSearchBar">
        <mat-form-field
          appearance="fill"
          class="mini-search-field search-field wp-100"
        >
          <input
            matInput
            placeholder="Search"
            #searchText
            autocomplete="off"
            (keyup)="onSearch($event)"
          />

          <mat-icon>search</mat-icon>
          <a
            href="javascript:void(0)"
            (click)="onCancel()"
            (click)="searchText.value = ''"
          >
            <mat-icon class="close">highlight_off</mat-icon>
          </a>
        </mat-form-field>
      </div>
      <div
        class="mat-table-wrapper"
        (scroll)="onTableScroll($event)"
        [ngClass]="showSearchBar ? 'mat-table-wrapper-full' : ''"
      >
        <table aria-describedby="side-list" mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef></th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              [ngClass]="{
                highlightRecord: isActive(element),
                active: isActive(element)
              }"
            >
              <div class="list-wrapper">
                <div class="d-flex align-items-center">
                  <mat-checkbox
                    [(ngModel)]="element.isSelected"
                    (change)="onCheckBoxSelected()"
                    disableRipple
                  >
                  </mat-checkbox>
                  <a
                    href="javascript:void(0)"
                    class="list-name clamp"
                    title="{{ element.name }}"
                    (click)="editClick(element.universalId)"
                    >{{ element.name }}</a
                  >
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="isRowHighlighted ? 'highlightRow' : ''"
          ></tr>
          <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell border-none"
              [ngClass]="'text-align-center'"
              [attr.colspan]="displayedColumns.length"
            >
              <span *ngIf="listParameters">No Records Found</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <app-side-list-actions
    class="side-list-actions-wrapper"
    [getModuleId]="getModuleId"
    [toggleSideList]="toggleSideList"
    [isViewPermission]="isViewPermission"
    (deleteClick)="deleteClick()"
    (exportClick)="exportClick($event, false)"
    (copyClick)="copyClick()"
    (cancelSelectionClick)="cancelSelectionClick()"
    (printClick)="printClick()"
    (archiveAndRestoreClick)="archiveAndRestoreClick($event)"
    [triggerNumberOfRecords]="triggerNumberOfRecords"
    (triggerReloadSideList)="onReloadSideList()"
  >
  </app-side-list-actions>
</div>
<div
  class="menu-toggle"
  (click)="!isSidebarPinned  ? menuToggle() : ''"
  [ngClass]="closeMenu ? 'toggle-icon' : ''"
>
  <mat-icon>{{
    closeMenu ? "keyboard_arrow_right" : "keyboard_arrow_left"
  }}</mat-icon>
</div>
